import {
  Button,
  Dialog,
  Portal,
  Text,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router';

const ConfirmationDialog = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate('/', { replace: true });
  };

  return (
    <Dialog.Root
      size="md"
      placement="center"
      open
      closeOnInteractOutside={false}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content bg="grayscale.fg" m={6}>
            <Dialog.Header>
              <Dialog.Title>
                Tudo certo!
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body>
              <Text fontSize="md">
                Uma mensagem foi enviada para o seu e-mail com as instruções para redefinir sua senha.
              </Text>
            </Dialog.Body>

            <Dialog.Footer>
              <Button
                bg="green.700"
                color="white"
                onClick={handleButtonClick}
              >
                Ok
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default ConfirmationDialog;
